export const toolsItems = [
  { name: "undo", arrow: false },
  { name: "redo", arrow: false, devided: true },
  // { name: "scale", arrow: true, value: 100, devided: true },
  // {
  //   name: "alignment",
  //   arrow: false,
  //   devided: true,
  //   value: {
  //     horizontal: [{ name: "start" }, { name: "center" }, { name: "end" }],
  //     vertical: [{ name: "start" }, { name: "center" }, { name: "end" }]
  //   }
  // },
  { name: "filter", arrow: true },
  { name: "columns", arrow: false }
];

export const toolsButtons = [];
